export const Types  = {
    SAVE_LIST_PARTNER : 'SAVE_LIST_PARTNER',
    SAVE_LIST_PARTNER_GROUP : 'SAVE_LIST_PARTNER_GROUP'
}